/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

/*COMPONENT*/
import UploadPhotoProfile from "../../Components/user/UploadPhotoProfile";
import LICENSE_DETAIL from "../../Components/user/LICENSE_DETAIL";
import HISTORY_PAYMENT from "../../Components/user/HISTORY_PAYMENT";
import API_KEY_TOKEN from "./API_KEY_TOKEN";

/*REDUX*/
import {
  logoutUser,
  getMapAccess,
  initApi,
  set_modal_quota_access,
  get_quota_access,
  get_quota_access_sini_ai,
  get_quota_ai_chat,
} from "../../App/actions/authActions";
import { clearProjectList } from "../../App/actions/projectActions";
import { clearFormList } from "../../App/actions/layerNewActions";
import { getUserPaymentList } from "../../App/actions/paymentActions";
import { getGroups } from "../../App/actions/groupActions";
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/
import pic_static from "../../Assets/svg/profile_pic_comment.svg";

/*DATA*/
import dict from "../../Data/dict.json";
import domain_list from "../../Data/domain_list";

/*CONST*/
const Paragrah = ({ title, value }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "5px 7px",
        width: "220px",
      }}
    >
      <p className="text_bold margin_bottom">{title}</p>
      {value ? (
        <span className="text_medium sub_color">{value}</span>
      ) : (
        <span className="text_medium sub_color">-</span>
      )}
    </div>
  );
};

// --- HELPER FUNCTION FOR PHONE FORMATTING ---
const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return null;

  // Convert to string to be safe
  const str = String(phoneNumber);

  // Regex to match: 62 (2 digits) + 4 digits + 4 digits + remaining digits
  // Input: 6285710100076
  // Match: [1]: 62, [2]: 8571, [3]: 0100, [4]: 076
  const match = str.match(/^(\d{2})(\d{4})(\d{4})(\d+)$/);

  if (match) {
    return `+${match[1]}-${match[2]}-${match[3]}-${match[4]}`;
  }

  // Fallback: return original if it doesn't match the specific format
  return phoneNumber;
};

const UserDashboard = ({
  auth,
  license_reducer,
  logoutUser,
  getUserPaymentList,
  getGroups,
  getMapAccess,
  clearProjectList,
  initApi,
  clearFormList,
  get_quota_access,
  get_quota_access_sini_ai,
  get_quota_ai_chat,
}) => {
  const params = useParams();
  const { search } = useLocation(); // Hook to track URL changes correctly
  const [menu_active, setMenuActive] = useState("license");

  useEffect(() => {
    const tab_list = ["license", "list_payment", "api_key"];
    const queryParams = new URLSearchParams(search);
    const tab_value = queryParams.get("tab");
    if (tab_list.includes(tab_value)) {
      setMenuActive(tab_value);
    }
  }, [search]); // Dependency is now a reactive variable from useLocation

  useEffect(() => {
    get_quota_access();
    get_quota_access_sini_ai();
    get_quota_ai_chat();
    getUserPaymentList();
    getGroups();
    getMapAccess();
  }, [
    get_quota_access,
    get_quota_access_sini_ai,
    get_quota_ai_chat,
    getUserPaymentList,
    getGroups,
    getMapAccess,
    params?.status,
  ]);

  const on_set_menu = (menu_active) => {
    setMenuActive(menu_active);
  };

  const handleInitApi = () => {
    const body = {};
    initApi(body);
  };

  const onLogoutClick = () => {
    const payment = localStorage.getItem("payment");
    if (payment) {
      localStorage.removeItem("payment");
    }
    logoutUser();
    clearProjectList();
    clearFormList();
  };

  const language = localStorage?.language || "ina";
  const { domain, user } = auth;
  const status_domain = domain_list?.[domain]?.status;

  const url_pic =
    user && user.profile_picture && user.profile_picture.url
      ? user.profile_picture.url
      : pic_static;

  return (
    <div className="main_container" style={{ minHeight: "90vh" }}>
      <main>
        <section>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              width: "100%",
              paddingTop: "1rem",
            }}
          >
            <div
              style={{
                marginRight: "2rem",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  height: "77px",
                  width: "77px",
                  display: "block",
                  border: "5px solid #dedede",
                  borderRadius: "13px",
                  backgroundImage: `url(${url_pic})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
              <UploadPhotoProfile />
            </div>

            <div style={{ flex: 1 }}>
              <div style={{ marginTop: "-5px" }}>
                {" "}
                <h1 className="text_big margin_bottom" style={{ marginTop: 0 }}>
                  {user?.full_name || user?.name}
                </h1>
              </div>
              <p className="text_medium margin_bottom">{user.bio || "-"}</p>

              <div
                className="margin_bottom"
                style={{ display: "flex", gap: "10px" }}
              >
                <Link
                  to={`/editprofile`}
                  className="button background_black"
                  data-mapid="clickEdit"
                  style={{ textDecoration: "none", display: "inline-block" }}
                >
                  {dict["Edit profile"][language]}
                </Link>
                <div
                  onClick={onLogoutClick}
                  className="button background_red"
                  style={{ cursor: "pointer" }}
                >
                  {dict["Sign out"][language]}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  backgroundColor: "#ffffff",
                  borderRadius: "7px",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  marginTop: "1.5rem",
                  width: "fit-content", // Fix: Prevents full width on wide screens
                  maxWidth: "100%", // Fix: Ensures mobile responsiveness
                  padding: "10px",
                }}
              >
                <Paragrah
                  title={dict["Username"][language]}
                  value={user.name}
                />
                <Paragrah title="E-mail" value={user.email} />

                {/* --- APPLIED PHONE FORMATTING HERE --- */}
                <Paragrah
                  title={dict["phone number"][language]}
                  value={formatPhoneNumber(user.phone_number)}
                />

                <Paragrah
                  title={dict["Birthday"][language]}
                  value={user.birthday}
                />
                <Paragrah
                  title={dict["industry"][language]}
                  value={user.industry}
                />
              </div>
            </div>
          </div>
        </section>

        <br />

        {status_domain !== "premium" && (
          <section>
            <div
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <main style={{ width: "100%" }}>
                <br />
                <button
                  className={`text_medium margin_right margin_bottom ${
                    menu_active === "license" ? "underline_active" : "sub_color"
                  }`}
                  style={{
                    marginRight: "33px",
                    background: "none",
                    border: "none",
                    padding: "10px 0",
                    cursor: "pointer",
                  }}
                  onClick={() => on_set_menu("license")}
                >
                  Lisensi
                </button>
                <button
                  className={`text_medium margin_right margin_bottom ${
                    menu_active === "list_payment"
                      ? "underline_active"
                      : "sub_color"
                  }`}
                  style={{
                    marginRight: "33px",
                    background: "none",
                    border: "none",
                    padding: "10px 0",
                    cursor: "pointer",
                  }}
                  onClick={() => on_set_menu("list_payment")}
                >
                  History Payment
                </button>
                <button
                  className={`text_medium margin_right margin_bottom ${
                    menu_active === "api_key" ? "underline_active" : "sub_color"
                  }`}
                  style={{
                    marginRight: "33px",
                    background: "none",
                    border: "none",
                    padding: "10px 0",
                    cursor: "pointer",
                  }}
                  onClick={() => on_set_menu("api_key")}
                >
                  API Key
                </button>
                <br />
                <br />

                {menu_active === "license" ? <LICENSE_DETAIL /> : null}
                {menu_active === "list_payment" ? <HISTORY_PAYMENT /> : null}
                {menu_active === "api_key" ? (
                  <API_KEY_TOKEN auth={auth} handleInitApi={handleInitApi} />
                ) : null}
              </main>
            </div>
          </section>
        )}
      </main>
      <Helmet>
        <title>{dict["Profile"][language]}</title>
        <meta name="description" content={dict["Profile"][language]} />
      </Helmet>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
  properties: state.properties,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {
  logoutUser,
  getUserPaymentList,
  getGroups,
  getMapAccess,
  clearProjectList,
  initApi,
  clearFormList,
  set_modal_quota_access,
  set_value_properties,
  get_quota_access,
  get_quota_access_sini_ai,
  get_quota_ai_chat,
})(UserDashboard);
